/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

enum ActionTypes {
  // Reset state
  RESET_STATE = 'gfm/app/RESET_STATE',
  RESET_CREATE_PRACTICE_FORM = 'gfm/app/RESET_CREATE_PRACTICE_FORM',
  RESET_START_CREATE_PRACTICE_FORM = 'gfm/app/RESET_START_CREATE_PRACTICE_FORM',
  RESET_CREATE_PRACTICE_FORM_ERROR = 'gfm/app/RESET_CREATE_PRACTICE_FORM_ERROR',
  // Set reducer
  SET_ERROR = 'gfm/app/SET_ERROR',
  SET_USERNAME = 'gfm/app/SET_USERNAME',
  SET_PASSWORD = 'gfm/app/SET_PASSWORD',
  SET_USERNAME_PASSWORD = 'gfm/app/SET_USERNAME_PASSWORD',
  SET_DATE_MIN_SELECTED = 'gfm/app/SET_DATE_MIN_SELECTED',
  SET_DATE_MAX_SELECTED = 'gfm/app/SET_DATE_MAX_SELECTED',
  SET_STATE_PRACTICE_SELECTED = 'gfm/app/SET_STATE_PRACTICE_SELECTED',
  SET_SELECTED_COURSES = 'gfm/app/SET_SELECTED_COURSES',
  RESET_SELECTED_COURSES = 'gfm/app/RESET_SELECTED_COURSES',
  SET_SELECTED_SOCIETIES = 'gfm/app/SET_SELECTED_SOCIETIES',
  SET_SELECTED_INSTRUCTORS = 'gfm/app/SET_SELECTED_INSTRUCTORS',
  SET_SELECTED_ALUMNO = 'gfm/app/SET_SELECTED_ALUMNO',
  RESET_SELECTED_STUDENTS = 'gfm/app/RESET_SELECTED_STUDENTS',
  SET_PROFILE_SELECTED = 'gfm/app/SET_PROFILE_SELECTED',
  SET_SELECTED_PROVINCE = 'gfm/app/SET_SELECTED_PROVINCE',
  SET_PRACTICA_AUDITORIA_SELECCIONADA = 'gfm/app/SET_PRACTICA_AUDITORIA_SELECCIONADA',
  SET_PRACTICA_RECLAMADA_SELECCIONADA = 'gfm/app/SET_PRACTICA_RECLAMADA_SELECCIONADA',
  SET_PRACTICA_RECHAZADA_SELECCIONADA = 'gfm/app/SET_PRACTICA_RECHAZADA_SELECCIONADA',
  SET_PRACTICA_VALIDADA_SELECCIONADA = 'gfm/app/SET_PRACTICA_VALIDADA_SELECCIONADA',
  RESET_VALIDAR_PRACTICA_REQUEST = 'gfm/practicas/RESET_VALIDAR_PRACTICA_REQUEST',
  SET_STATION_SELECTED = 'gfm/app/SET_STATION_SELECTED',
  SET_DESTINY_SELECTED = 'gfm/app/SET_DESTINY_SELECTED',
  SET_CREATION_SELECTED = 'gfm/app/SET_CREATION_SELECTED',
  SET_SELECTED_SCHOOL = 'gfm/app/SET_SELECTED_SCHOOL',
  SET_ID_TYPE_PRACTICE_SELECTED = 'gfm/app/SET_ID_TYPE_PRACTICE_SELECTED',
  SET_TYPE_PRACTICE_SELECTED = 'gfm/app/SET_TYPE_PRACTICE_SELECTED',
  SET_DISPOSICION_PRACTICE_SELECTED = 'gfm/app/SET_DISPOSICION_PRACTICE_SELECTED',
  SET_TYPE_SERVICE_SELECTED = 'gfm/app/SET_TYPE_SERVICE_SELECTED',
  SET_VEHICLE_SELECTED = 'gfm/app/SET_VEHICLE_SELECTED',
  SET_TRAIN_SELECTED = 'gfm/app/SET_TRAIN_SELECTED',
  SET_OBSERVATIONS_SELECTED = 'gfm/app/SET_OBSERVATIONS_SELECTED',
  SET_TURN_SELECTED = 'gfm/app/SET_TURN_SELECTED',
  SET_STATE_TYPE = 'gfm/app/SET_STATE_TYPE',
  SET_PRACTICA_EDITAR = 'gfm/app/SET_PRACTICA_EDITAR',
  SET_IS_AUDITAR = 'gfm/app/SET_IS_AUDITAR',
  SET_MSG_SUBMIT = 'gfm/app/SET_MSG_SUBMIT',
  SET_MODAL_DRAFT_TYPE = 'gfm/app/SET_MODAL_DRAFT_TYPE',
  SET_PRACTICA_CREADA = 'gfm/app/SET_PRACTICA_CREADA',
  SET_SELECTED_COURSE = 'gfm/app/SET_SELECTED_COURSE',
  SET_USER_LIST = 'gfm/app/SET_USER_LIST',
  SET_OBSERVACIONES_INSTRUCTOR = 'gfm/app/SET_OBSERVACIONES_INSTRUCTOR',
  SET_OBSERVACIONES_ALUMNO = 'gfm/app/SET_OBSERVACIONES_ALUMNO',
  // Form Crear/Editar práctica
  // selectedJourney
  SET_JORNADA_SELECCIONADA = 'gfm/app/SET_JORNADA_SELECCIONADA',

  // Alerts
  SET_ALERT = 'gfm/app/SET_ALERT',

  // Loading
  SET_LOADING = 'gfm/app/SET_LOADING',

  SET_START_DATE_TIME_SELECTED_JOURNEY = 'gfm/app/SET_START_DATE_TIME_SELECTED_JOURNEY',
  SET_START_TIME_SELECTED_JOURNEY_PRISTINE = 'gfm/app/SET_START_TIME_SELECTED_JOURNEY_PRISTINE',
  SET_DATE_START_JOURNEY_HAD_CHANGE = 'gfm/app/SET_DATE_START_JOURNEY_HAD_CHANGE',
  SET_FINISH_DATE_TIME_SELECTED_JOURNEY = 'gfm/app/SET_FINISH_DATE_TIME_SELECTED_JOURNEY',
  SET_FINISH_TIME_SELECTED_JOURNEY_PRISTINE = 'gfm/app/SET_FINISH_TIME_SELECTED_JOURNEY_PRISTINE',
  SET_START_DATE_TIME_SELECTED_PREPARATION = 'gfm/app/SET_START_DATE_TIME_SELECTED_PREPARATION',
  SET_START_TIME_SELECTED_PREPARATION_PRISTINE = 'gfm/app/SET_START_TIME_SELECTED_PREPARATION_PRISTINE',
  SET_START_DATE_TIME_SELECTED_SERVICE = 'gfm/app/SET_START_DATE_TIME_SELECTED_SERVICE',
  SET_START_TIME_SELECTED_SERVICE_PRISTINE = 'gfm/app/SET_START_TIME_SELECTED_SERVICE_PRISTINE',
  SET_FINISH_DATE_TIME_SELECTED_SERVICE = 'gfm/app/SET_FINISH_DATE_TIME_SELECTED_SERVICE',
  SET_FINISH_TIME_SELECTED_SERVICE_PRISTINE = 'gfm/app/SET_FINISH_TIME_SELECTED_SERVICE_PRISTINE',
  SET_FINISH_HOUR_SERVICE = 'gfm/app/SET_FINISH_HOUR_SERVICE',
  SET_START_JOURNEY_SELECTED_ERROR = 'gfm/app/SET_START_JOURNEY_SELECTED_ERROR',
  SET_START_JOURNEY_SELECTED_ERROR_DRAFT = 'gfm/app/SET_START_JOURNEY_SELECTED_ERROR_DRAFT',
  SET_FINISH_DATE_JOURNEY_SELECTED_ERROR = 'gfm/app/SET_FINISH_DATE_JOURNEY_SELECTED_ERROR',
  SET_FINISH_DATE_JOURNEY_SELECTED_ERROR_DRAFT = 'gfm/app/SET_FINISH_DATE_JOURNEY_SELECTED_ERROR_DRAFT',
  SET_FINISH_TIME_JOURNEY_SELECTED_ERROR = 'gfm/app/SET_FINISH_TIME_JOURNEY_SELECTED_ERROR',
  SET_FINISH_TIME_JOURNEY_SELECTED_ERROR_DRAFT = 'gfm/app/SET_FINISH_TIME_JOURNEY_SELECTED_ERROR_DRAFT',
  SET_START_SERVICE_SELECTED_ERROR = 'gfm/app/SET_START_SERVICE_SELECTED_ERROR',
  SET_START_PREPARATION_SELECTED_ERROR = 'gfm/app/SET_START_PREPARATION_SELECTED_ERROR',
  SET_START_SERVICE_SELECTED_ERROR_DRAFT = 'gfm/app/SET_START_SERVICE_SELECTED_ERROR_DRAFT',
  SET_FINISH_DATE_SERVICE_SELECTED_ERROR = 'gfm/app/SET_FINISH_DATE_SERVICE_SELECTED_ERROR',
  SET_FINISH_DATE_SERVICE_SELECTED_ERROR_DRAFT = 'gfm/app/SET_FINISH_DATE_SERVICE_SELECTED_ERROR_DRAFT',
  SET_FINISH_TIME_SERVICE_SELECTED_ERROR = 'gfm/app/SET_FINISH_TIME_SERVICE_SELECTED_ERROR',
  SET_FINISH_TIME_SERVICE_SELECTED_ERROR_DRAFT = 'gfm/app/SET_FINISH_TIME_SERVICE_SELECTED_ERROR_DRAFT',
  RESET_SELECTED_SERVICES_AND_JOURNEYS = 'gfm/app/RESET_SELECTED_SERVICES_AND_JOURNEYS',
  SET_MINUTES_PRACTICE_SELECTED = 'gfm/app/SET_MINUTES_PRACTICE_SELECTED',
  SET_MINUTES_PRACTICE_SELECTED_ERROR = 'gfm/app/SET_MINUTES_PRACTICE_SELECTED_ERROR',
  SET_MINUTES_CE_SELECTED = 'gfm/app/SET_MINUTES_CE_SELECTED',
  SET_MINUTES_PENDING_CE_SELECTED = 'gfm/app/SET_MINUTES_PENDING_CE_SELECTED',
  SET_MINUTES_OTHER_SELECTED = 'gfm/app/SET_MINUTES_OTHER_SELECTED',
  SET_MINUTES_PENDING_OTHER_SELECTED = 'gfm/app/SET_MINUTES_PENDING_OTHER_SELECTED',
  SET_MINUTES_DRAFT_SELECTED = 'gfm/app/SET_MINUTES_DRAFT_SELECTED',
  SET_MINUTES_PREPARATION_SELECTED = 'gfm/app/SET_MINUTES_PREPARATION_SELECTED',

  GET_INFO_USER_PROFILE = 'gfm/app/GET_INFO_USER_PROFILE',
  SET_INFO_USER_PROFILE_STATUS = 'gfm/app/SET_INFO_USER_PROFILE_STATUS',
  UPDATE_INFO_USER_PROFILE = 'gfm/app/UPDATE_INFO_USER_PROFILE',
  SET_UPDATE_INFO_USER_PROFILE = 'gfm/app/SET_UPDATE_INFO_USER_PROFILE',

}

export default ActionTypes;
